import { Toast } from "vant";
import md5 from "js-md5";
import { config } from "@/common/apis";
import axios from "axios";
import store from "../../store";
export function login(employee_code) {
	let userNumber = employee_code;
	if (!userNumber) {
		Toast("未获取到人员信息，请退出重试");
		return;
	}
	let para = {
		userNumber: userNumber,
		sign: md5(userNumber + config.SALT)
	};
	return new Promise((resolve, reject) => {
		axios({
			method: "POST",
			url: config.API_BASE_URI + "app/sus/auth/token",
			data: para,
			timeout: 1000 * 60 // 请求超时时间默认60秒
		})
			.then(res => {
				if (res.data.data.authToken) {
					console.log(store);
					let authToken = res.data.data.authToken;
					store.dispatch("syncToken", {
						authToken: authToken,
						userNumber: userNumber
					});
					sessionStorage.setItem("authToken", authToken);
					sessionStorage.setItem("userNumber", userNumber);
					resolve();
				} else {
					Toast(res.data.data.msg);
					reject();
				}
			})
			.catch(err => {
				reject();
				Toast(err.message);
			});
	});
}
